// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hChsAS4rdT0q5X0M{opacity:.4}.rXuF05tmIA5NpdvA{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabledEmployeePicker": `hChsAS4rdT0q5X0M`,
	"archiveWorkspaceModalContent": `rXuF05tmIA5NpdvA`
};
export default ___CSS_LOADER_EXPORT___;
